"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  ${dir("rtl")`
    transform: scaleX(-1);
  `}
`;
const Notebook = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M19 2H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-4 18.5H5.5v-17H7v6.27c0 .29.19.39.42.24l1.83-1.15L11.08 10c.23.15.42 0 .42-.24V3.5H15zm3.5 0H17v-17h1.5z", children: " " })
] });
var Notebook_default = Notebook;
export {
  Notebook_default as default
};
